import React from "react";
import { elastic as Menu } from "react-burger-menu";
import { Link } from "react-router-dom";

function Burger(props) {
  return (
    <Menu className="block md:hidden lg:hidden">
      <Link className="menu-item" to="/">
        Home
      </Link>
      <Link className="menu-item" to="/activities">
        Activities
      </Link>
      <Link className="menu-item" to="/about">
        About Us
      </Link>
      <Link className="menu-item" to="/committee">
        Committee
      </Link>
      <Link className="menu-item" to="/gallery">
        Gallery
      </Link>
      <Link className="menu-item" to="/contact">
        Contact Us
      </Link>
    </Menu>
  );
}

export default Burger;
